import React, { useContext, createContext } from 'react';
import { useNotifications } from './useNotifications';

export const NotificationContext = createContext<ReturnType<typeof useNotifications> | null>(null);

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotificationContext must be used within NotificationProvider');
  }
  return context;
};
